// WithMessageMetaData.jsx
import React from 'react';
import PropTypes from 'prop-types';

export class WithMessageMetaData extends React.PureComponent {
  fetchMessageDetail = () => {
    const {
      messageId,
      likes,
      unlocks,
      viewCount,
      hasFetchedMessageDetail,
      fetchMessageDetail,
    } = this.props;
    const isMissingData = !likes && !unlocks && !viewCount;

    if (messageId && !hasFetchedMessageDetail && isMissingData) {
      fetchMessageDetail({ messageId });
    }
  };

  componentDidMount() {
    this.nextTick = setTimeout(() => {
      this.fetchMessageDetail();
    }, 0);
  }

  componentDidUpdate(prevProps) {
    const { messageId } = this.props;
    if (prevProps.messageId !== messageId) {
      this.fetchMessageDetail();
    }
  }

  render() {
    const {
      children,
      likes,
      unlocks,
      viewCount,
      likePercentage,
      price,
      rating,
      expiresAtUnix,
      isPublished,
    } = this.props;
    return children({
      likes,
      unlocks,
      viewCount,
      likePercentage,
      price,
      rating,
      expiresAtUnix,
      isPublished,
    });
  }
}

WithMessageMetaData.propTypes = {
  children: PropTypes.func.isRequired,
  fetchMessageDetail: PropTypes.func.isRequired,
  likePercentage: PropTypes.number,
  likes: PropTypes.number,
  messageId: PropTypes.string,
  unlocks: PropTypes.number,
  price: PropTypes.number,
  rating: PropTypes.number,
  viewCount: PropTypes.string,
  hasFetchedMessageDetail: PropTypes.bool,
  expiresAtUnix: PropTypes.number,
  isPublished: PropTypes.bool,
};

WithMessageMetaData.defaultProps = {
  fetchMessageDetail: () => null,
  messageId: '',
  likePercentage: null,
  viewCount: '-',
  price: 0,
  hasFetchedMessageDetail: true,
  expiresAtUnix: null,
  isPublished: false,
};

export default WithMessageMetaData;
